module.exports = __webpack_public_path__ + "static/media/arrow-left.417c9f24.svg";